module.exports = __webpack_public_path__ + "static/logo-with-water-1fc60c3447ae07ed980e8359090a1e95.png";